import React from "react";
import "../PageStyles.css";

const Missions = () => {
  return (
    <section className="page-section about-section">
      <h1>Our Mission: To Shape the World</h1>

      <p>
        Our mission is to raise awareness of the world’s most pressing challenges. We equip
        students with the research, communication, and leadership skills needed to devise real
        solutions. With an English-based academic system led by native speakers, Ottomun
        transforms language learning into a bridge for global dialogue.
      </p>

      <p className="about-footer">
        Join us at Ottomun — don’t just simulate change. <strong>Create it.</strong>
      </p>

   
    </section>
  );
};

export default Missions;
